import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  async getAteliers(idFormation) {
    const response = await axios.get("/api/ateliers/formation/" + idFormation);
    return response.data;
  },
  async getAteliersByReferentSuaio() {
    const response = await axios.get("/api/gestion/ateliers");
    return response.data;
  },
  async getAtelier(id) {
    const response = await axios.get("/api/ateliers/" + id);
    return response.data;
  },
  async addAtelier(atelier) {
    const response = await axios.post("/api/ateliers", atelier);
    return response.data;
  },
  async updateAtelier(id, atelier) {
    const response = await axios.put("/api/ateliers/" + id, atelier);
    return response.data;
  },
  async deleteAtelier(id) {
    const response = await axios.delete("/api/ateliers/" + id);
    return response.data;
  },
  async getAteliersByAnimateur() {
    const response = await axios.get("/api/suaio/ateliers");
    return response.data;
  },
  async getCsvFile(critere, id) {
    const url = `/api/gestion/ateliers/csv/${critere}/${id}`;
    const response = await axios.get(url);
    return response.data;
  },
};
